import main from '@trading/pages/main.vue';
export default [
  {
    path: 'trading',
    redirect: 'trading/list',
    component: main,
    children: [
      {
        path: 'list',
        name: 'trading/list',
        meta: { title: '交易订单查询', auth: true },
        component: () => import('@trading/pages/index-list.vue'),
      },
      {
        path: 'refund',
        name: 'trading/refund',
        meta: { title: '退款订单管理', auth: true },
        component: () => import('@trading/pages/refund-list.vue'),
      },
    ],
  },
  {
    path: 'trading/list/detail',
    name: 'trading/list/detail',
    meta: { title: '订单详情', auth: true },
    component: () => import('@trading/pages/detail.vue'),
  },
  {
    path: 'trading/refund/detail',
    name: 'trading/refund/detail',
    meta: { title: '对账单详情', auth: true },
    component: () => import('@trading/pages/refund-detail.vue'),
  },
  {
    path: 'trading/applyRefund',
    name: 'trading/applyRefund',
    meta: { title: '申请退款', auth: true },
    component: () => import('@trading/pages/applyRefund.vue'),
  },
];

